<form [formGroup]="form">
  <div class="comment-container">
    <div *ngFor="let commentLog of commentLogs">
      <div>
        <div class="mb-2">
          <span>{{ commentLog?.user?.name }}</span>
          <span class="ml-2">{{ commentLog?.date | date: dateFormat }}</span>
        </div>
        <mat-card appearance="outlined" class="comment mb-2">
          <pre class="brk-wrd" [innerHTML]="commentLog?.comment"></pre>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="input-container div-comment">
    <mat-form-field appearance="outline">
      <div class="comment-field">
        <textarea
          formControlName="comment"
          matInput
          matTextareaAutosize
          matAutosizeMinRows="4"
          matAutosizeMaxRows="4"
          placeholder="Type a new comment"
        ></textarea>
        <button
          mat-stroked-button
          color="accent"
          (click)="addComment()"
          [disabled]="isDisabled"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-form-field>
  </div>
</form>
